export default __webpack_public_path__ + "static/media/box2.deed7166.svg";